import { FC } from 'react';

export const EmoticonSad: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 10C8 9.44772 8.44772 9 9 9H9.01C9.56228 9 10.01 9.44772 10.01 10C10.01 10.5523 9.56228 11 9.01 11H9C8.44772 11 8 10.5523 8 10ZM14 10C14 9.44772 14.4477 9 15 9H15.01C15.5623 9 16.01 9.44772 16.01 10C16.01 10.5523 15.5623 11 15.01 11H15C14.4477 11 14 10.5523 14 10ZM12 16C11.1959 16 10.4062 16.3928 9.76063 17.1492C9.40209 17.5693 8.7709 17.6192 8.35081 17.2606C7.93073 16.9021 7.88084 16.2709 8.23937 15.8508C9.18606 14.7416 10.4991 14 12 14C13.5009 14 14.8139 14.7416 15.7606 15.8508C16.1192 16.2709 16.0693 16.9021 15.6492 17.2606C15.2291 17.6192 14.5979 17.5693 14.2394 17.1492C13.5938 16.3928 12.8041 16 12 16Z"
			fill="currentColor"
		/>
	</svg>
);
